import BaseNormalizer from "./BaseNormalizer";

const orderUnitsNormalizer = Object.create(BaseNormalizer).init(
  [
    "id",
    "approvalState",
    "deletable",
    "ean",
    "edmNumber",
    "bestBeforeOnDeliveryInDays",
    "images",
    "name",
    "netPriceCents",
    "orderableFrom",
    "orderableTo",
    "orderUnitsProducts.id",
    "orderUnitsProducts.orderUnitId",
    "orderUnitsProducts.productCount",
    "orderUnitsProducts.productId",
    "orderUnitsProducts.discounted",
    "orderUnitType",
    "products.depositValue",
    "products.id",
    "products.images",
    "products.name",
    "products.productVariantName",
    "products.purchasingPrice",
    "products.purchasingPriceCents",
    "products.rrp",
    "products.rrpCents",
    "products.vat",
    "products.ean",
    "shippingUnitDepositType",
    "shippingUnitDepositValueCents",
    "shippingUnitGrossWeight",
    "shippingUnitHeight",
    "shippingUnitLength",
    "shippingUnitNetWeight",
    "shippingUnitPackaging",
    "shippingUnitWidth",
    "startup.companyBackground",
    "startup.deliveryTimeFrame",
    "startup.id",
    "startup.logo",
    "startup.name",
    "startup.website",
    "startup.lineSupplier",
    "startup.edekaContract",
    "startup.minimumOrderValue",
    "supplierArticleNumber",
    "totalProductCount",
    "vat",
    "isLive",
  ],
  ["orderUnitsProducts", "products"],
);

export default orderUnitsNormalizer;
